export enum eVisitorDocumentTypes {
  OSOBNA_ISKAZNICA_DOMAĆA = '051',
  OSOBNA_ISKAZNICA_STRANA = '027',

  VOZAČKA_DOZVOLA_DOMAĆA = '103',
  VOZAČKA_DOZVOLA_STRANA = '032',

  OSOBNA_PUTOVNICA_DOMAĆA = '028',
  OSOBNA_PUTOVNICA_STRANA = '002',

  DJEČJA_PUTOVNICA_DOMAĆA = '033',
  DJEČJA_PUTOVNICA_STRANA = '005',

  ZDRAVSTVENA_ISKAZNICA = '999',
}
